/**
 * Trims whitespace and removes non-printable Unicode control characters
 * (category `\p{C}`, including zero-width space `\u200B`).
 *
 * Regular `String.prototype.trim()` does not remove characters like `\u200B`.
 * `null` / `undefined` are returned unchanged (like `value?.trim()`).
 *
 * @see https://www.baeldung.com/java-replace-non-printable-unicode-characters
 */
export function deepTrim(value: string): string;
export function deepTrim(value: null | undefined): null | undefined;
export function deepTrim(value: string | null | undefined): string | null | undefined {
	if (value == null) {
		return value;
	}
	return value.replace(/\p{C}/gu, "").trim();
}
